import React from 'react'
import Text from '../../atoms/Text'
import { ReactComponent as Edit } from '../../../assets/icons/edit_green.svg'
import { FaCalendarAlt } from 'react-icons/fa'
import { HiMiniClock } from 'react-icons/hi2'
import moment from 'moment'

const CollectionDetails = ({ onPressEdit = () => {}, cartData = {} }) => {
  const formatTimeRange = (timeRange) => {
    const [start, end] = timeRange.split(' - ')
    const startMoment = moment(start, 'HH:mm')
    const endMoment = moment(end, 'HH:mm')

    const period =
      startMoment.hours() < 12
        ? 'Morning'
        : startMoment.hours() < 18
          ? 'Afternoon'
          : 'Evening'

    return `${period}, ${startMoment.format('hh:mm')} - ${endMoment.format('hh:mm')}`
  }

  return (
    <div className="flex flex-col gap-4 px-4 py-1">
      <div className="w-full flex flex-row items-center justify-between">
        <Text
          tag={'p'}
          variant={'title'}
          size={'medium'}
          className={'text-text-primary'}
        >
          Sample Collection Details
        </Text>
        <button
          onClick={onPressEdit}
          className="flex flex-row items-center gap-[2px]"
        >
          <Text
            tag={'p'}
            variant={'label'}
            size={'large'}
            bold={'true'}
            className={'text-text-brand-tertiary'}
          >
            Edit
          </Text>
          <Edit className="min-h-4 min-w-4" />
        </button>
      </div>
      <div className="bg-WHITE p-4 rounded-4 flex flex-col gap-4">
        <div className="flex flex-row items-center gap-3 pb-4 border-b border-b-border-secondary">
          <FaCalendarAlt className="min-h-6 min-w-6 text-foreground-quaternary" />
          <Text
            tag={'p'}
            variant={'body'}
            size={'large'}
            className={'text-text-primary'}
          >
            {moment(cartData.appointment_date, 'YYYY-MM-DD').format(
              'dddd, D MMM, YYYY',
            )}
          </Text>
        </div>
        <div className="flex flex-row items-center gap-3">
          <HiMiniClock className="min-h-6 min-w-6 text-foreground-quaternary" />
          <Text
            tag={'p'}
            variant={'body'}
            size={'large'}
            className={'text-text-primary'}
          >
            {formatTimeRange(cartData.slot_time)}
          </Text>
        </div>
      </div>
    </div>
  )
}

export default CollectionDetails
